import { createClassName } from 'utils/createClassName';

import './roundPressControlStyles.scss';

export const createRoundPressControlClassName = createClassName(
  'roundPressControl'
);
